// routes
import { PATH_DASHBOARD } from './routes/paths';

// API
// ----------------------------------------------------------------------

const DEFAULT_HOST = 'https://api.airstudiosa.com';
const DEFAULT_STOREFRONT = 'https://airstudiosa.com';

const normalizeApiHost = (url) =>
  String(url || DEFAULT_HOST)
    .replace(/\/$/, '')
    .replace(/\/graphql\/?$/, '');

export const HOST = normalizeApiHost(
  process.env.REACT_APP_API_HOST || DEFAULT_HOST
);
export const HOST_API = process.env.REACT_APP_API_GRAPHQL || `${HOST}/graphql`;

/** Live customer storefront — used for product preview (eye icon). */
export const STOREFRONT_URL = String(
  process.env.REACT_APP_STOREFRONT_URL || DEFAULT_STOREFRONT
).replace(/\/$/, '');

const wsBase =
  process.env.REACT_APP_WS_URL ||
  HOST.replace(/^https:\/\//, 'wss://').replace(/^http:\/\//, 'ws://');
export const WS_GRAPHQL = `${wsBase.replace(/\/$/, '')}/graphql`;

/** Set REACT_APP_GRAPHQL_WS=true only when the API supports WebSocket subscriptions. */
export const GRAPHQL_WS_ENABLED = process.env.REACT_APP_GRAPHQL_WS === 'true';

const LEGACY_API_HOSTS = new Set([
  'airstudioai.hnhsofttechsolutions.com',
  'airstudioaiapi.hnhsofttechsolutions.com',
]);

const rewriteLegacyApiUrl = (raw) => {
  try {
    const parsed = new URL(raw);
    if (LEGACY_API_HOSTS.has(parsed.hostname.toLowerCase())) {
      return `${HOST}${parsed.pathname}${parsed.search || ''}`;
    }
  } catch {
    // fall through
  }
  return raw;
};

export const mediaUrl = (path) => {
  if (!path) return '';
  const raw = String(path).trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw)) {
    const rewritten = rewriteLegacyApiUrl(raw);
    if (process.env.NODE_ENV === 'development') {
      try {
        const parsed = new URL(rewritten);
        if (/^(localhost|127\.0\.0\.1)$/i.test(parsed.hostname)) {
          return `${HOST}${parsed.pathname}${parsed.search || ''}`;
        }
      } catch {
        // fall through
      }
    }
    return rewritten;
  }
  return `${HOST}${raw.startsWith('/') ? raw : `/${raw}`}`;
};

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX;


// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.product.list; // as '/dashboard/app'

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you set settings.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeColorPresets: 'default',
  themeLayout: 'horizontal',
  themeStretch: false,
};
